__turbopack_context__.v({
  "actions": "sidebarCart-module-scss-module__03QDrq__actions",
  "darkLink": "sidebarCart-module-scss-module__03QDrq__darkLink",
  "link": "sidebarCart-module-scss-module__03QDrq__link",
  "prodItem": "sidebarCart-module-scss-module__03QDrq__prodItem",
  "productsWrapper": "sidebarCart-module-scss-module__03QDrq__productsWrapper",
  "sidebarCart": "sidebarCart-module-scss-module__03QDrq__sidebarCart",
  "totalPrice": "sidebarCart-module-scss-module__03QDrq__totalPrice",
  "zeroState": "sidebarCart-module-scss-module__03QDrq__zeroState",
});
